
export interface IUploadedDocument {
  uid: string;
  filename: string;
  fileSize: string;
  fileType: string;
  createDate?: string;
  createTime?: string;
  createDateTime?: string;
  mediaType?: string;
  version?: string;
  fileExtension:string;
}

export class UploadedDocumentViewModel {

  public prettyFileName: string;

  constructor(public document: IUploadedDocument) {
    this.prettyFileName = this.cleanFileName(document.filename);
  }

  private cleanFileName(fileName: string): string {

    // file names are appended with dates. ex: test1-2021-06-17-13-19-22-225.txt. remove to display
    const expMatch = `-\\d{4}(-\\d{2}){5}-\\d{1,3}`;
    const regexMatch = new RegExp(expMatch, 'gi');

    const dateMatch = fileName.match(regexMatch);
    if ( dateMatch ) {
      return fileName.replace(regexMatch, '');
    }

    return fileName;
  }
}
